// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {AccessOption} from '../../../util/permissions';
import {AddProjectMembersDrawer} from './AddProjectMembersDrawer';
import {ProjectRoleMember} from './utils';

type AddProjectMembersProps = {
  projectMembers: ProjectRoleMember[];
  projectTeamName: string;
  projectName: string;
  projectID: string;
  projectAccess: AccessOption;
};

export const AddProjectMembers = ({
  projectMembers,
  projectTeamName,
  projectName,
  projectID,
  projectAccess,
}: AddProjectMembersProps) => {
  const [isOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        className="font-semibold"
        startIcon="add-new"
        onClick={() => setIsModalOpen(true)}>
        Add user
      </Button>
      <AddProjectMembersDrawer
        isOpen={isOpen}
        setIsModalOpen={setIsModalOpen}
        handleModalClose={() => setIsModalOpen(false)}
        currentProjectMembers={projectMembers}
        projectID={projectID}
        projectName={projectName}
        projectTeamName={projectTeamName}
        projectAccess={projectAccess}
      />
    </>
  );
};
